import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirmar-actividad-irregular',
  templateUrl: './confirmar-actividad-irregular.component.html',
  styleUrls: ['./confirmar-actividad-irregular.component.scss'],
})
export class ConfirmarActividadIrregularComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      accion_autorizada: [
        values ? values.accion_autorizada : false,
        [Validators.required],
      ],
      copia: [values ? values.copia : false, [Validators.required]],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
